import React, { FC, forwardRef } from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import { MuiRadioGroupProps } from './types';

const Radio: FC<MuiRadioGroupProps> = forwardRef<HTMLInputElement, MuiRadioGroupProps>((
  {
    children,
    onChange,
    defaultValue,
    value,
    ...restProps
  },
  ref,
) => {
  return (
    <RadioGroup
      onChange={onChange}
      defaultValue={defaultValue}
      value={value}
      ref={ref}
      {...restProps}
    >
      {children}
    </RadioGroup>
  );
});

export default Radio;
